// import { sleep } from 'modules/Utils';

const hlocale = window.hlocale;

// const translating = 'translating';
// const translated = 'translated';

// const state = {
//   collectionName: {
//     documentID1: translating,
//     documentID2: translated
//   }
// };
// const translatedData = {
//   collectionName: {
//     documentID2: {
//       title: 'translated data',
//       description: 'translated data'
//     }
//   }
// };

// const fieldsToSetTranslatedText = [
//   'title',
//   'description',
//   'text',
//   'introduction'
// ];

// const setTranslatedText = (_id, collectionName) => {
//   const translatedCollectionData = translatedData[collectionName];

//   if (!translatedCollectionData || !translatedCollectionData[_id]) {
//     return;
//   }

//   fieldsToSetTranslatedText.forEach(field => {
//     const translatedText = translatedCollectionData[_id][field];
//     if (translatedText) {
//       // normal text
//       const textClass = `${field}TLTE${_id}`;
//       $(`.${textClass}`).html(translatedText);
//       $(`.${textClass}`).removeClass(textClass);

//       // normal text
//       const dataClass = `${field}TLDATA${_id}`;
//       $(`.${dataClass}`).data(field, translatedText);
//       $(`.${dataClass}`).removeClass(dataClass);

//       // handlebars br
//       if (!window.lineBreakAndParseLink) {
//         return;
//       }

//       const brClass = `${field}TLBR${_id}`;
//       $(`.${brClass}`).html(
//         window.lineBreakAndParseLink(translatedText).string
//       );
//       $(`.${brClass}`).removeClass(brClass);
//     }
//   });
// };

const checkTranslate = () => {
  return (
    hlocale !== 'ja' 
    // &&
    // (
    //   window.Gdata &&
    //   window.Gdata.CurrentMap &&
    //   window.Gdata.CurrentMap.ori &&
    //   window.Gdata.CurrentMap.ori[0] &&
    //   window.MapClass 
    // )
  );
};

// const mutateDocument = (doc, collectionName) => {
//   if (!doc) {
//     return;
//   }

//   const translatedCollectionData = translatedData[collectionName];
//   const { _id } = doc;
//   // mutation
//   doc.lang = doc.lang || {};
//   doc.lang[hlocale] = translatedCollectionData[_id];
// };

// const mutateOnTranslated = async (doc, collectionName) => {
//   const collectionState = state[collectionName];
//   const { _id } = doc;

//   while (collectionState[_id] !== translated) {
//     await sleep();
//   }

//   mutateDocument(doc, collectionName);
// };

// collection param will be mutated
const translateCollection = async (/*collection, collectionName*/) => {
  return;
  // if (!checkTranslate()) {
  //   return;
  // }

  // if (!state[collectionName]) {
  //   state[collectionName] = {};
  // }
  // if (!translatedData[collectionName]) {
  //   translatedData[collectionName] = {};
  // }

  // const collectionState = state[collectionName];
  // const translatedCollectionData = translatedData[collectionName];

  // const untranslatedList = {};
  // _.forEach(collection, doc => {
  //   const { _id, lang = {}, update_datetime, registration_datetime } = doc;
  //   const docState = collectionState[_id];
  //   const translatedDoc = translatedCollectionData[_id];

  //   if (
  //     lang[hlocale] &&
  //     (!update_datetime ||
  //       registration_datetime === update_datetime ||
  //       lang[hlocale].update_datetime === update_datetime)
  //   ) {
  //     // already has lang obj and lang is up to date
  //     if (!translatedDoc) {
  //       translatedCollectionData[_id] = lang[hlocale];
  //       collectionState[_id] = translated;
  //     }
  //     return;
  //   } else if (
  //     docState === translated &&
  //     (!update_datetime ||
  //       !translatedDoc.update_datetime ||
  //       translatedDoc.update_datetime === update_datetime)
  //   ) {
  //     // translation translated
  //     console.log(`translated - ${_id}`);
  //     mutateDocument(doc, collectionName);
  //     setTranslatedText(_id, collectionName);
  //     return;
  //   } else if (docState === translating) {
  //     // translating - do nothing, just wait for completion
  //     console.log(`translating - ${_id}`);
  //     mutateOnTranslated(doc, collectionName);
  //     return;
  //   }

  //   collectionState[_id] = translating;
  //   untranslatedList[_id] = doc;
  // });

  // try {
  //   const allKeys = _.map(untranslatedList, ({ _id }) => _id);

  //   if (allKeys.length === 0) {
  //     return;
  //   }

  //   // translate per 5 documents
  //   const chunks = _.chunk(allKeys, 5);

  //   for (const keys of chunks) {
  //     const ajaxOptions = {
  //       type: 'POST',
  //       contentType: 'application/json',
  //       data: JSON.stringify({
  //         language: hlocale,
  //         collection: collectionName,
  //         keys
  //       })
  //     };

  //     await $.ajax({
  //       url: `${AS.domains.route}/api/Translate`,
  //       ...ajaxOptions
  //     });

  //     const result = await $.ajax({
  //       url: `${window.AS.domains.api}/GET_TRANSLATED_DATA`,
  //       ...ajaxOptions
  //     });

  //     console.log(result);
  //     console.log('TRANSLATED RESULT----');

  //     result.forEach(translatedDoc => {
  //       const { _id, lang = {} } = translatedDoc;
  //       translatedCollectionData[_id] = {
  //         _id,
  //         ...lang[hlocale]
  //       };
  //       collectionState[_id] = translated;
  //       mutateDocument(untranslatedList[_id], collectionName);
  //       setTranslatedText(_id, collectionName);
  //     });
  //   }
  // } catch (e) {
  //   console.log(e);
  //   console.log('translation error occurred');
  // }
};

const decodeHTMLEntities = (text) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = text;
  let replacedText = tempDiv.innerHTML
    .replace(/&lt;(\/?)span(.*?)&gt;/g, '<$1span$2>')
    .replace(/&lt;(\/?)strong(.*?)&gt;/g, '<$1strong$2>')
    .replace(/&lt;br\s*\/?&gt;/g, '<br/>');
  return replacedText;
};

const resolveTranslated = (doc, fieldName, isBr, skipCheckTranslate) => {
  let text = doc[fieldName];
  if (checkTranslate() || skipCheckTranslate) {
    const { lang = [] } = doc;
    if (lang[hlocale] && lang[hlocale][fieldName]) {
      text = lang[hlocale][fieldName];
    }
  }

  if (isBr && window.lineBreakAndParseLink) {
    text = window.lineBreakAndParseLink(text);
  }

  const decodedText = decodeHTMLEntities(text);
  return decodedText;
};

const translatingStatus = status => {
  const text = `<span style="color: #aaa; display: block;">${window.resolveLang(
    status
  )}...</span>`;
  return new window.Handlebars.SafeString(text);
};

const checkTranslating = (doc, ignoreUpdate) => {
  if (!checkTranslate()) {
    return;
  }

  const { lang_cache = {}, lang = {}, update_datetime } = doc;

  if (ignoreUpdate && lang[hlocale]) {
    return;
  }

  if (lang[hlocale]) {
    return;
  }

  if (lang_cache[hlocale] && lang_cache[hlocale].indexOf('error') > -1) {
    return translatingStatus('翻訳失敗');
  }

  if (
    (update_datetime &&
      lang[hlocale] &&
      lang[hlocale].update_datetime !== update_datetime) ||
    lang_cache[hlocale] !== 'complete'
  ) {
    return translatingStatus('翻訳中');
  }

  // if (
  //   update_datetime &&
  //   lang[hlocale] &&
  //   lang[hlocale].update_datetime === update_datetime
  // ) {
  //   // already translated
  //   return;
  // }

  // if (!update_datetime && lang[hlocale]) {
  //   // already translated
  //   return;
  // }

  // if (!lang_cache[hlocale] || lang_cache[hlocale] !== 'complete') {
  //   const text = `<span style="color: #aaa; display: block;">${window.resolveLang(
  //     '翻訳中'
  //   )}...</span>`;
  //   return new window.Handlebars.SafeString(text);
  // }
};

window.translateCollection = translateCollection;
window.resolveTranslated = resolveTranslated;
window.checkTranslating = checkTranslating;
